export default "__VITE_ASSET__CbQ5TclE__"